/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import saveIcon from '@iconify/icons-eva/save-outline';

// material
import { Stack, Typography, Switch } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { editItem } from '../../fetch';
import { sessionActions } from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

// ----------------------------------------------------------------------
// components

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export default function UnitsChose() {
  const t = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const session = useSelector(selectSession);

  const formik = useFormik({
    initialValues: session,
    onSubmit: async (values) => {
      const body = { ...values };
      delete body.permission;

      const response = await editItem('users', session.id, body);
      if (response.ok) {
        enqueueSnackbar(t('profile_Changed'), {
          variant: 'success'
        });
        const result = await response.json();
        dispatch(sessionActions.update(await result));
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      }

      setSubmitting(false);
    }
  });
  const { handleSubmit, isSubmitting, getFieldProps, setSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction="row" spacing={6}>
            <Stack direction="row" spacing={1}>
              <Icon
                icon={getFieldProps('privateAccount').value ? 'mdi:lock' : 'mdi:lock-open-variant'}
                width={24}
                height={24}
              />
              <Typography variant="h6">{t('STG_Privacy_PrivateAccount')}</Typography>
            </Stack>
            <Switch
              {...label}
              {...getFieldProps('privateAccount')}
              checked={!!getFieldProps('privateAccount').value}
            />
          </Stack>
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            startIcon={<Icon icon={saveIcon} />}
          >
            {t('btn_Save')}
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
